import React, { useState } from 'react'
import { Trans, useTranslation } from 'next-i18next'
import {
  Box,
  Button,
  Checkbox,
  Dialog,
  Stack,
  Text
} from '@machobear/design-system'
import { useDispatch } from 'react-redux'

import { ReactComponent as Illustration } from './external-link-alt-illustration.svg'

export const ListingExternalEditNoticeModal = ({
  externalInfo,
  visible,
  closeModal
}: {
  visible: boolean
  closeModal: () => void
  externalInfo?: {
    external_url: string
    source_info_abbreviation: string
    source_info_name: string
  }
}) => {
  const { t } = useTranslation()
  const [checked, setChecked] = useState(false)
  const dispatch = useDispatch()
  const abbreviation = externalInfo?.source_info_abbreviation
  const sourceName = externalInfo?.source_info_name

  const handleOnClick = async () => {
    if (checked) {
      dispatch.flags.createFlag({
        name: 'skip_edit_your_listing_on_trreb_modal',
        value: '1'
      })
    }
    window.open(externalInfo?.external_url, '_blank', 'noopener,noreferrer')
    closeModal()
  }

  const toggleCheckbox = () => {
    setChecked(checkedState => !checkedState)
  }

  const handleCloseModal = () => {
    setChecked(false)
    closeModal()
  }

  return (
    <Dialog
      id={`edit-listing-on-${abbreviation?.toLowerCase()}-dialog`}
      illustration={
        <Box marginTop="large">
          <Illustration />
        </Box>
      }
      open={visible}
      onClose={handleCloseModal}
      width="xsmall"
      title={`${t(
        'l.listing.edit_listing_trreb.title.text',
        `Edit your listing on`
      )} ${abbreviation}`}
      description={
        <Stack space="gutter" align="left">
          <Stack space="xlarge" align="left">
            <Text>
              <Trans
                i18nKey="l.listing.edit_listing_trreb.description.1.text"
                values={{ sourceName, abbreviation }}
              >
                This listing is syndicated from MLS® with the {{ sourceName }} (
                {{ abbreviation }}).
              </Trans>
            </Text>
            <Text>
              <Trans
                i18nKey="l.listing.edit_listing_trreb.description.2.text"
                values={{ abbreviation }}
              >
                Please edit listing details directly on {{ abbreviation }}. Any
                changes will be updated on liv.rent within 2 hours.
              </Trans>
            </Text>
          </Stack>
          <Text tone="tertiary" size="xsmall">
            <Trans
              i18nKey="l.listing.edit_listing_trreb.description.3.text"
              values={{ abbreviation }}
            >
              liv.rent is not responsible for any content sourced from{' '}
              {{ abbreviation }}
            </Trans>
          </Text>
        </Stack>
      }
    >
      <Stack space="small" align="center">
        <Button onClick={handleOnClick}>
          <Trans
            i18nKey="l.listing.edit_listing_trreb.button.text"
            values={{ abbreviation }}
          >
            Go to {{ abbreviation }}
          </Trans>
        </Button>
        <Checkbox
          id={`do-not-show-edit-listing-on-${abbreviation?.toLowerCase()}-modal`}
          label={t(
            'l.listing.edit_listing_trreb.do_not_show.text',
            'Do not show this again'
          )}
          onChange={toggleCheckbox}
          checked={checked}
        />
      </Stack>
    </Dialog>
  )
}
